import {
    Component, ElementRef, EventEmitter,
    HostListener, Output, ViewContainerRef
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Configuration } from '../../shared/services/configuration';
import { HttpClientCustom } from '../../shared/services/http.client';
import { Auth } from '../../shared/services/auth';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { SharedData } from '../../shared/sharedData';

@Component({
    selector: 'org-unit-type',
    templateUrl: 'organizationUnitList.html',
})

export class OrgUnitTypePageComponent {
    @Output()
    public updateRate: any = new EventEmitter();
    public pageSize: any = 10;
    public page = 1;
    public startingPage: any = 0;
    public endingPage: any = 10;
    public collectionSize: any;
    public _baseUrl: any;
    public orgData: any = [];
    public trackHides = null;
    public orgUnitTypeData: any = [];
    public orgUnitTypePageData: any = [];
    public showLoading: any = false;

    // refresh gif
    public disable:any;

    public orgUnitTypeFilter = {
        nameOrCode: null,
        codeList: [],
        nameList:[],
        ids:[],
        level:[],
        pageSize: 10,
        page: 1
    }
    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public router: Router,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _auth: Auth,
        public eRef: ElementRef,
        public share: SharedData,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public _toaster: ToasterComponent,
        public translate: TranslateService,
        public vcr: ViewContainerRef) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getAllOrgUnitType();

    }

    // pagination functions
    public onPageChange(event: number): void {
        let that = this;
        if (event === 1) {
            that.startingPage = 1;
            that.endingPage = 10;
        } else {
            that.startingPage = 1 + that.pageSize;
            if (that.collectionSize > that.endingPage) {
                that.endingPage = event + that.endingPage;
            } else {
                that.endingPage = that.collectionSize;
            }
        }
        that.page = event;
        that.getAllOrgUnitType();
    }

    public OnPageSizeChanged(val) {
        
        this.pageSize = val;
        this.getAllOrgUnitType();
    }


    public addOrganizationUnitType() {
        this.share.saveData({ OrganizationUnitTypeData: null, type: 'ADD' });
        this.router.navigate(['menu/addOrgUnitType']);
    }

    public editOrgUnitType(val) {
        this.share.saveData({ OrganizationUnitTypeData: val, type: 'EDIT' });
        this.router.navigate(['menu/addOrgUnitType']);
    }
    public deleteOrgUnitType(val) {
        this.share.saveData({ OrganizationUnitTypeData: val, type: 'DELETE' });
        this.router.navigate(['menu/addOrgUnitType']);

      
    }

    public getAllOrgUnitType() {
        
        let self = this;
        self.showLoading = true;
        let url = self._baseUrl + 'v1/webAdmin/orgUnitType/search';
        // let url = self._baseUrl + 'v1/webAdmin/orgUnitType/getAll';
        self.http.post(url,self.orgUnitTypeFilter).subscribe((result) => {
            self.orgUnitTypeData = result.content;
            self.orgUnitTypePageData = result;
            if (self.orgUnitTypeData.length === 0) {
                self.showLoading = false;
            }
            self.collectionSize = result.totalElements;
            if (result.last) {
                self.endingPage = self.collectionSize;
            }
        }, (error) => {
            self.showLoading = false;
            console.log('getAllOrgUnitType error catch', error);
        });
    }

    public empActions(val) {
        // this.hide = val;
    }
    public empTableActions(value) {
        if (this.trackHides === value) {
            this.trackHides = null;
        } else {
            this.trackHides = value;
        }

    }

    @HostListener('window:click', ['$event'])
    public clickOut(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            setTimeout(() => {
                this.trackHides = null;
            }, 100);
        }
    }
    public clicked() {
        this.trackHides = null;
    }

    public onRefresh(){
    //showing loading here
        this.getAllOrgUnitType();
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/organizationUnit/organizationUnitList.ts